/* eslint no-useless-escape: 0, no-console: 0 */

export default class ContactJs {
  constructor() {
    this.isValid = false;
    this.contactForm = document.querySelector('.js-contact-form');
    this.typesInput = document.querySelectorAll('.js-group-types');

    if (this.contactForm && this.typesInput && this.typesInput.length) {
      this.sendButton = this.contactForm.querySelector('.js-send-btn');

      this.init();
      this.loadingOverlay();
    }
  }

  init() {
    const selectInput = this.contactForm.querySelector('.js-type');

    // Init types
    this.typesInput.forEach((typeInput) => {
      typeInput.classList.add('hidden');
      typeInput.removeAttribute('required');
    });

    selectInput.addEventListener('change', () => {
      this.typesInput.forEach((typeInput) => {
        typeInput.classList.add('hidden');
        typeInput.removeAttribute('required');
      });

      const selectorValue = `.js-group-type-${selectInput.options[selectInput.selectedIndex].value}`;
      const typeInput = document.querySelector(selectorValue);

      if (typeInput) {
        typeInput.classList.remove('hidden');
        typeInput.setAttribute('required', 'required');
      }
    });
  }

  loadingOverlay() {
    this.sendButton.addEventListener('click', (e) => {
      e.preventDefault();

      // Check if all required inputs are filled.
      this.checkRequiredInputs();

      if (this.isValid) {
        document.querySelector('.js-loading-overlay').classList.add('open');
        document.querySelector('body').classList.add('loading');

        setTimeout(() => {
          this.contactForm.submit();
        }, 1500);
      }
    });
  }

  checkRequiredInputs() {
    const requiredInputs = this.contactForm.querySelectorAll('[required]');

    requiredInputs.forEach((input) => {
      if (!input.value) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
    });
  }
}
